/**
 * Danger ↔ loot visual language (docs/04 "Tehlike ↔ ganimet dili"). Pure
 * visuals — hitboxes, damage and drops are untouched.
 *  - ENEMY shots: hot red/orange rim, dark or hollow core, spikes/fins and
 *    a pulsing warning glow (frames cycle at `pulseFps`).
 *  - FUSED enemy shots (split-on-timer bombs/eggs): a fuse spark, a pulsing
 *    danger ring that grows to the blast hint as the fuse runs down.
 *  - PICKUPS: faceted gem silhouettes, white sparkle, gentle bob, magnet trail.
 */
export const PROJECTILE_LOOK = {
  /** Halo strength per pulse frame (one frame per entry) */
  pulse: [0.7, 1, 1.3, 1] as ReadonlyArray<number>,
  pulseFps: 10,
  /** Fuse countdown steps; each step has 2 spark-flicker frames */
  fuseSteps: 5,
  fuseFlickerFps: 16,
  /**
   * Fused textures draw this much larger than the hitbox so the danger ring
   * fits around the body — the body itself keeps the usual hitbox size.
   */
  fuseSpriteScale: 1.8,
  /** Body radius as a share of a fused texture's half-size (≈ 0.71 / scale) */
  fuseBodyFrac: 0.39,
  /** The danger ring grows from just outside the body to this share */
  fuseRingMax: 0.94,

  /** Pickup bob (px, rad/s) — only while the gem rests, not while pulled */
  gemBob: 3,
  gemBobSpeed: 3.2,
  /** Magnet trail: a pulled gem always shows `trailMin` of the streak,
   *  growing to full at `trailFull` px/s (the close-range snap) */
  trailMin: 0.4,
  trailFull: 620,
  /** Trail length at full speed (× texture width) and its peak alpha */
  trailStretch: 1.1,
  trailAlpha: 0.75,
  /** Loot texture frame rate (the white sparkle wanders across the cut) */
  sparkleFps: 6,
  /**
   * Gem cut by piece value (polish 1): from the first value the piece is a
   * CLUSTER of 3 cuts, from the second a HOARD pile with a halo — a new
   * silhouette, not just a bigger sprite (the size still grows too).
   */
  gemCuts: { yellow: [9, 15], red: [3, 6] } as const,
} as const;
